import { Component, OnInit, Input } from '@angular/core';
import { AssetCardDetails } from 'src/app/models/assetCardDetails';
import { HttpService } from '../../shared/services/http.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/modules/userModule/shared/user.service';

@Component({
  selector: 'app-last-visited',
  templateUrl: './last-visited.component.html',
  styleUrls: ['./last-visited.component.css']
})
export class LastVisitedComponent implements OnInit {

  @Input()
  assets: Array<any> = new Array<any>();

  assetsCardDetails: Array<AssetCardDetails> = new Array<AssetCardDetails>()

  constructor(private httpService: HttpService, private router: Router, private userService: UserService) { }

  ngOnInit() {
    this.fetchCardDetails();
  }

  fetchCardDetails() {
    let url = this.router.url;
    let assetsIds = this.assets.map(asset => asset.assetId).slice(0, 10);
    assetsIds.splice(assetsIds.indexOf(url.split('/')[url.split('/').length - 1]), 1)
    this.httpService.getAssetCardDetails(assetsIds, this.userService.loggendInUser.userEmailId).subscribe(
     (data: any) => {
        this.assetsCardDetails = data.assetCardDetails;
      }, err => {
        console.log(err);
      }, () => {
        console.log("Done");
      }
    )
  }

}
